module.exports = "/_next/static/images/suprabha-3bbf26bb063abb841d2e757988c37f7c.png";